import { createSelector } from 'reselect';
import {
  formValueSelector, getFormMeta, isInvalid, getFormValues,
} from 'redux-form';

const shippingInfoFormSelector = formValueSelector('shippingInfo');
export const zipcodeSelector = (state) => shippingInfoFormSelector(state, 'zipcode');
export const citySelector = (state) => shippingInfoFormSelector(state, 'city');
export const addressSelector = (state) => shippingInfoFormSelector(state, 'address1');
export const selectedStateIdSelector = (state) => Number(shippingInfoFormSelector(state, 'state_id'));
export const shippingInfoFormMetaSelector = (state) => getFormMeta('shippingInfo')(state);
export const selectedCountryIdSelector = (state) => shippingInfoFormSelector(state, 'country_id') && Number(shippingInfoFormSelector(state, 'country_id'));
export const shippingInfoFormValuesSelector = (state) => getFormValues('shippingInfo')(state);
export const shippingInfoInvalidSelector = (state) => isInvalid('shippingInfo')(state);

export const shippingSelector = (state) => state.shipping;
export const shippingInfoSelector = createSelector(shippingSelector, (shipping) => shipping.info);
export const shippingEditModeEnabledSelector = createSelector(
  shippingSelector,
  (shipping) => shipping.editModeEnabled,
);
export const shippingLoadingSelector = createSelector(
  shippingSelector,
  (shipping) => shipping.loading,
);
export const shippingPreviewModeEnabledSelector = createSelector(
  shippingSelector,
  (shipping) => shipping.previewModeEnabled,
);
export const shippingAddressPreviewModeEnabledSelector = createSelector(
  shippingSelector,
  (shipping) => shipping.addressPreviewModeEnabled,
);
export const shipmentsSelector = createSelector(
  shippingSelector,
  (shipping) => shipping.shipments,
);
